import 'css/Loader.scss';
const Loader = (props) => {
  let isDark = false;

  if (props) {
    isDark = Boolean(props.isDark);
  }
  return <div className={`lds-ring ${isDark ? 'lds-ring--dark' : 'lds-ring--light'}`}><div></div><div></div><div></div><div></div></div>;
}
export default Loader;